import * as React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Tab as MuiTab, TabProps as MuiTabProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    '&:focus': { boxShadow: 'none' },
    '&:hover:not(.Mui-selected)': {
      color: theme.colors.fgPrimaryBase,
    },
    color: theme.colors.fgSubtle,
    minHeight: theme.spacing(8),
    minWidth: theme.spacing(8),
    opacity: 1,
    padding: `${theme.spacing(1)}px ${theme.spacing(1.5)}px`,
    [theme.breakpoints.up('sm')]: {
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
    textTransform: 'none',
  },
  selected: {
    color: theme.colors.fgPrimaryBase,
  },
  wrapper: {
    '& > svg:not(:only-child)': {
      marginBottom: 6, // explicitly declaring here so as to maintain the 64px stacked height
    },
    [theme.breakpoints.up('sm')]: {
      alignContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
      '& > svg, & > svg:first-child': {
        marginBottom: 0,
        '&:not(:only-child)': {
          marginRight: theme.spacing(1),
        },
      },
    },
  },
}));

const useSizeStyles = makeStyles((theme) => ({
  xlarge: { minHeight: theme.spacing(8) },
  large: { minHeight: theme.spacing(6) },
}));

export type TabSize = 'xlarge' | 'large';

export interface TabProps extends MuiTabProps {
  component?: React.ElementType;
  /**
   * default size is large
   */
  size?: TabSize;
  to?: string;
}

/**
 * A styled Tab component to be used with TabBar
 * @see {@link https://material-ui.com/api/tab/} Material API docs for props
 */
const Tab: React.FunctionComponent<TabProps> = ({ icon, size = 'large', ...props }) => {
  const classes = useStyles();
  const sizeClasses = useSizeStyles();
  return (
    <MuiTab
      classes={classes}
      className={clsx({
        [sizeClasses.large]: size === 'large',
        [sizeClasses.xlarge]: size === 'xlarge',
      })}
      icon={icon}
      {...props}
    />
  );
};

export default Tab;
